import { escapeElement } from "./escape-element";
var XmlText = (function () {
    function XmlText(value) {
        this.value = value;
    }
    XmlText.prototype.toString = function () {
        return escapeElement("" + this.value);
    };
    return XmlText;
}());
export { XmlText };
